import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportArrayToExcel = async (data, fileName = "export.xlsx") => {
  if (!data || data.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  // Define columns with uppercase headers
  worksheet.columns = Object.keys(data[0]).map((key) => ({
    header: key.toUpperCase(),
    key: key,
  }));

  // Add data rows
  worksheet.addRows(data);

  // Bold only the first row (header)
  worksheet.getRow(1).font = { bold: true };

  // Export to file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, fileName);
};
